import script from "./pay-money-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./pay-money-dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__